// Action types are prefixed so their keys in the global loading/error reducers
// cannot collide with another feature's generic names.
export const releaseNotesConstants = {
  GET_READER_NOTES_REQUEST: 'RELEASE_NOTES_GET_READER_NOTES_REQUEST',
  GET_READER_NOTES_SUCCESS: 'RELEASE_NOTES_GET_READER_NOTES_SUCCESS',
  GET_READER_NOTES_FAILURE: 'RELEASE_NOTES_GET_READER_NOTES_FAILURE',

  GET_MANAGE_NOTES_REQUEST: 'RELEASE_NOTES_GET_MANAGE_NOTES_REQUEST',
  GET_MANAGE_NOTES_SUCCESS: 'RELEASE_NOTES_GET_MANAGE_NOTES_SUCCESS',
  GET_MANAGE_NOTES_FAILURE: 'RELEASE_NOTES_GET_MANAGE_NOTES_FAILURE',

  GET_NOTE_REQUEST: 'RELEASE_NOTES_GET_NOTE_REQUEST',
  GET_NOTE_SUCCESS: 'RELEASE_NOTES_GET_NOTE_SUCCESS',
  GET_NOTE_FAILURE: 'RELEASE_NOTES_GET_NOTE_FAILURE',
  CLEAR_NOTE: 'RELEASE_NOTES_CLEAR_NOTE',

  GET_RELEASES_REQUEST: 'RELEASE_NOTES_GET_RELEASES_REQUEST',
  GET_RELEASES_SUCCESS: 'RELEASE_NOTES_GET_RELEASES_SUCCESS',
  GET_RELEASES_FAILURE: 'RELEASE_NOTES_GET_RELEASES_FAILURE',

  SAVE_NOTE_REQUEST: 'RELEASE_NOTES_SAVE_NOTE_REQUEST',
  SAVE_NOTE_SUCCESS: 'RELEASE_NOTES_SAVE_NOTE_SUCCESS',
  SAVE_NOTE_FAILURE: 'RELEASE_NOTES_SAVE_NOTE_FAILURE',

  DELETE_NOTE_REQUEST: 'RELEASE_NOTES_DELETE_NOTE_REQUEST',
  DELETE_NOTE_SUCCESS: 'RELEASE_NOTES_DELETE_NOTE_SUCCESS',
  DELETE_NOTE_FAILURE: 'RELEASE_NOTES_DELETE_NOTE_FAILURE',

  BULK_NOTES_REQUEST: 'RELEASE_NOTES_BULK_NOTES_REQUEST',
  BULK_NOTES_SUCCESS: 'RELEASE_NOTES_BULK_NOTES_SUCCESS',
  BULK_NOTES_FAILURE: 'RELEASE_NOTES_BULK_NOTES_FAILURE',

  SAVE_RELEASE_REQUEST: 'RELEASE_NOTES_SAVE_RELEASE_REQUEST',
  SAVE_RELEASE_SUCCESS: 'RELEASE_NOTES_SAVE_RELEASE_SUCCESS',
  SAVE_RELEASE_FAILURE: 'RELEASE_NOTES_SAVE_RELEASE_FAILURE',

  DELETE_RELEASE_REQUEST: 'RELEASE_NOTES_DELETE_RELEASE_REQUEST',
  DELETE_RELEASE_SUCCESS: 'RELEASE_NOTES_DELETE_RELEASE_SUCCESS',
  DELETE_RELEASE_FAILURE: 'RELEASE_NOTES_DELETE_RELEASE_FAILURE',

  GET_UNREAD_COUNT_REQUEST: 'RELEASE_NOTES_GET_UNREAD_COUNT_REQUEST',
  GET_UNREAD_COUNT_SUCCESS: 'RELEASE_NOTES_GET_UNREAD_COUNT_SUCCESS',
  GET_UNREAD_COUNT_FAILURE: 'RELEASE_NOTES_GET_UNREAD_COUNT_FAILURE',

  MARK_SEEN_REQUEST: 'RELEASE_NOTES_MARK_SEEN_REQUEST',
  MARK_SEEN_SUCCESS: 'RELEASE_NOTES_MARK_SEEN_SUCCESS',
  MARK_SEEN_FAILURE: 'RELEASE_NOTES_MARK_SEEN_FAILURE',

  UPLOAD_IMAGE_REQUEST: 'RELEASE_NOTES_UPLOAD_IMAGE_REQUEST',
  UPLOAD_IMAGE_SUCCESS: 'RELEASE_NOTES_UPLOAD_IMAGE_SUCCESS',
  UPLOAD_IMAGE_FAILURE: 'RELEASE_NOTES_UPLOAD_IMAGE_FAILURE',

  GET_PETASENSE_NOTES_REQUEST: 'RELEASE_NOTES_GET_PETASENSE_NOTES_REQUEST',
  GET_PETASENSE_NOTES_SUCCESS: 'RELEASE_NOTES_GET_PETASENSE_NOTES_SUCCESS',
  GET_PETASENSE_NOTES_FAILURE: 'RELEASE_NOTES_GET_PETASENSE_NOTES_FAILURE',

  DECIDE_PETASENSE_NOTE_REQUEST: 'RELEASE_NOTES_DECIDE_PETASENSE_NOTE_REQUEST',
  DECIDE_PETASENSE_NOTE_SUCCESS: 'RELEASE_NOTES_DECIDE_PETASENSE_NOTE_SUCCESS',
  DECIDE_PETASENSE_NOTE_FAILURE: 'RELEASE_NOTES_DECIDE_PETASENSE_NOTE_FAILURE',

  GET_TEMPLATE_REQUEST: 'RELEASE_NOTES_GET_TEMPLATE_REQUEST',
  GET_TEMPLATE_SUCCESS: 'RELEASE_NOTES_GET_TEMPLATE_SUCCESS',
  GET_TEMPLATE_FAILURE: 'RELEASE_NOTES_GET_TEMPLATE_FAILURE'
};

// Mirrors ReleaseNoteTypeEnum / ReleaseNoteStatusEnum in cloud
// (app/models/release_notes.py); the API validates against the same values.
export const NOTE_TYPES = {
  FEATURE: 'feature',
  IMPROVEMENT: 'improvement',
  FIX: 'fix'
};

export const NOTE_STATUSES = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published'
};

export const ALL = 'all';

// Release list scopes understood by GET /release-notes/releases.
export const RELEASE_SCOPE = {
  LIVE: 'live',
  ALL: 'all'
};

export const ROUTES = {
  READER: '/release-notes',
  MANAGE: '/release-notes/manage',
  NEW: '/release-notes/manage/new',
  note: id => `/release-notes/${id}`,
  edit: id => `/release-notes/manage/edit/${id}`,
  // A partner's new note made from a Petasense one (Use as template).
  fromTemplate: id => `/release-notes/manage/new?from=${id}`,
  FROM_PETASENSE: '/release-notes/manage?tab=petasense'
};

// The manage page's tabs for a partner's admins: their own notes, and
// Petasense's to adapt. Petasense staff only ever see the first.
export const MANAGE_TABS = {
  OWN: 'own',
  PETASENSE: 'petasense'
};

// A partner's decision on a Petasense note (cloud ReleaseNoteDecisionEnum),
// with `to_review` for none yet.
export const DECISIONS = {
  TO_REVIEW: 'to_review',
  ADAPTED: 'adapted',
  SKIPPED: 'skipped'
};

export const DECISION_TAB_LABELS = {
  to_review: 'To review',
  adapted: 'Adapted',
  skipped: 'Skipped',
  all: 'All'
};

// A note shows the New badge for this many days after its date.
export const NEW_WINDOW_DAYS = 21;

// How many notes the bell's popover previews.
export const BELL_PREVIEW_COUNT = 3;

// Field limits, matching the cloud schemas.
export const LIMITS = {
  title: 255,
  summary: 500,
  area: 100,
  release: 50,
  label: 100
};

export const READER_QUERY_KEYS = ['type', 'area', 'release', 'q'];

export const MANAGE_SORTS = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
  TITLE: 'title',
  TITLE_DESC: 'title-desc'
};

// The most notes one bulk request may carry; the API refuses more.
export const BULK_MAX_NOTES = 200;

// Screenshots are uploaded, not linked: a note's markdown refers to one as
// ![caption](rn-image://<id>), which the reader turns into the API's image URL.
export const IMAGE_SCHEME = 'rn-image://';
// Where a screenshot still uploading will land in the body; never saved.
export const UPLOAD_SCHEME = 'rn-upload://';
// A screenshot a note made from a Petasense template still has to replace:
// the template swaps each of ours for this, followed by /<id> of the screenshot
// it stands in for (cloud SCREENSHOT_PLACEHOLDER).
export const SCREENSHOT_PLACEHOLDER = 'rn-image://replace';
// What getTemplate resolves to for a Petasense note that can never be loaded.
export const TEMPLATE_UNAVAILABLE = 'unavailable';
export const UPLOAD_STATUS = {
  QUEUED: 'queued',
  UPLOADING: 'uploading',
  FAILED: 'failed'
};

// Matching the cloud's ReleaseNoteImage limits.
export const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
export const IMAGE_MAX_BYTES = 5 * 1024 * 1024;

// What a note of each type should look like: the body the editor offers to
// start from, in English until the page's language has its own.
export const BODY_TEMPLATES = {
  feature: 'The problem this solves, then what is new, in one or two sentences.\n\n## What you can do\n\n- **First capability:** what it lets you do.\n- **Second capability:** what it lets you do.\n\n## How to use it\n\n1. Open ...\n2. Select ...\n\n## Good to know\n\n- Who can use it, any limits, and what stays the same.',
  improvement: '**Before:** how it worked.\n\n**Now:** what is different, and why that helps.',
  fix: 'What was going wrong, in the words a user would use. One or two sentences.'
};

export const BODY_GUIDES = {
  feature: 'New feature: a title of up to 8 words that says what the user gets, one screenshot after the opening lines, then the three sections from the template.',
  improvement: 'Improvement: a title like "X now does Y", then Before and Now in a few lines. It shows as one line in the Improvements list.',
  fix: 'Bug fix: start the title with "Fixed" and say what was wrong. It shows as one line in the Bug fixes list; the body is optional.'
};

// What each status means for readers, shown under the status pills.
export const STATUS_HINTS = {
  draft: 'Only Petasense staff can see a draft.',
  draftPartner: 'Only your admins can see a draft.',
  scheduled: 'Readers see it from the day you choose.',
  published: 'Readers see it as soon as you save. It is dated the day it is published.'
};

// Why a note cannot be saved yet; shown beside the disabled save button.
export const SAVE_BLOCKERS = {
  saving: 'Saving...',
  uploading: 'Save is available once uploads finish',
  unchanged: 'No changes to save',
  title: 'Add a title to save',
  release: 'Choose a release to save',
  date: 'Choose the day it goes live',
  placeholder: 'Replace every screenshot placeholder to publish or schedule',
  invalid: 'Fix the highlighted fields to save'
};

// What the manage page can do to several notes at once; the API's names.
export const BULK_ACTIONS = {
  PUBLISH: 'publish',
  DRAFT: 'draft',
  DELETE: 'delete'
};

// What the page says once a bulk action has gone through.
export const BULK_DONE = {
  publish: '{{count}} updates published',
  draft: '{{count}} updates moved to draft',
  delete: '{{count}} updates deleted'
};

// Asked before a bulk action that takes notes away from readers.
export const BULK_CONFIRM = {
  delete: {
    message: 'Delete {{count}} updates?',
    detail: 'Deleted updates are gone for readers and from this list.',
    proceed: 'Delete'
  },
  draft: {
    message: 'Move {{count}} updates to draft?',
    detail: 'Readers stop seeing a draft. Publishing it again dates it that day.',
    proceed: 'Move to draft'
  }
};
